module.exports = __webpack_public_path__ + "files/df8ff9265d35f9da179478580c414d8f.png";